import React, { useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import FullScreenLoader from "./FullScreenLoader"; // Preserving the loader usage if needed, or we can use the table's built-in loader
// We'll trust the parent to handle full screen loading if they want, but here we can support the table's loading state.

const CustomDatatableGrid = ({
  columns,
  data,
  loading = false,
  onExportExcel,
  onExportPDF,
  initialState = {},
  enableColumnOrdering = true,
  enableColumnFilters = true,
  enableSorting = true,
  ...props
}) => {
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [sorting, setSorting] = useState([]);
  const [columnSizing, setColumnSizing] = useState({});
  const [filterModes, setFilterModes] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  // Initialize columnOrder from columns prop if not provided
  useEffect(() => {
    if (columns && columns.length > 0) {
      // If we haven't set an order yet, or if columns changed significantly
      setColumnOrder(columns.map((col) => col.id || col.accessorKey));
    }
  }, [columns]);

  return (
    <div className="custom-mrt-table-wrapper">
      <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnFilters={enableColumnFilters}
        enableGlobalFilter
        enableColumnDragging={enableColumnOrdering}
        enableColumnResizing
        enableHiding
        enableColumnOrdering={enableColumnOrdering}
        enableSorting={enableSorting}
        enableStickyHeader
        enableColumnFilterModes
        defaultColumn={{
          minSize: 100,
          maxSize: 1000,
        }}
        layoutMode="grid"
        initialState={{
          showColumnFilters: true,
          density: "compact",
          ...initialState,
        }}
        state={{
          columnOrder,
          columnVisibility,
          sorting,
          columnSizing,
          columnFilters,
          isLoading: loading,
          ...props.state,
        }}
        onColumnOrderChange={(newOrder) =>
            setColumnOrder(
              typeof newOrder === 'function' ? newOrder(columnOrder) : newOrder
            )
        }
        onColumnVisibilityChange={setColumnVisibility}
        onSortingChange={setSorting}
        onColumnSizingChange={setColumnSizing}
        onColumnFiltersChange={(updater) => {
             const newFilters = typeof updater === "function" ? updater(columnFilters) : updater;
             setColumnFilters(newFilters);
             // Update filter modes logic if needed, mimicking StudentList
             const newFilterModes = { ...filterModes };
             newFilters.forEach((filter) => {
               // Logic from StudentList to sync filter modes can be added if we had access to filterFn
               // For now, we trust MRT default behavior or parent config
             });
             setFilterModes(newFilterModes);
        }}
        muiTableProps={{
          className: "custom-mrt-table",
        }}
        muiTableHeadCellProps={{
          className: "custom-mrt-table-head-cell",
        }}
        muiTableBodyCellProps={{
          className: "custom-mrt-table-body-cell",
        }}
        renderTopToolbarCustomActions={({ table }) => (
          <div className="d-flex gap-1 align-items-center">
            {onExportExcel && (
              <button
                type="button"
                className="btn btn-with-icon-and-tooltip"
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Export to Excel"
                onClick={onExportExcel}
              >
                <i className="text-success fs-7 fas fa-file-excel"></i>
              </button>
            )}
            {onExportPDF && (
              <button
                type="button"
                className="btn btn-with-icon-and-tooltip"
                data-tooltip-id="global-tooltip"
                data-tooltip-content="Export to PDF"
                onClick={onExportPDF}
              >
                <i className="text-danger fs-7 fas fa-file-pdf"></i>
              </button>
            )}
          </div>
        )}
        muiTopToolbarProps={{
          className: "custom-mrt-toolbar", // Added custom class
        }}
        muiSearchTextFieldProps={{
          sx: {
            width: "160px", // Explicit small width
            minWidth: "100px",
            maxWidth: "200px",
          },
          variant: "outlined",
          size: "small",
        }}
        {...props}
      />
    </div>
  );
};

export default CustomDatatableGrid;
